import classNames from 'classnames';
import { ReactNode } from 'react';

interface IProps {
  count: number;
  classes?: string;
  isRight?: boolean;
  children?: ReactNode;
}

export const BadgeWithText = ({ count, classes, isRight, children }: IProps) => (
  <span className={classNames('BadgeWithText', classes, { 'BadgeWithText--right': isRight })} badge-with-text={count}>
    {children}
  </span>
);
